import { useShipments } from "./dashboardApi";
import { NoDataFound } from "../../../common/NoDataFound";
import {
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Card } from "../../ui/Card";
import DatePickerEl from "../../ui/DatePickerEl";
import { Dayjs } from "dayjs";
import useDashboardShipmentFilter, {
  PaymentData,
} from "./useDashboardShipmentFilter";

export const tableCellStyle = {
  textAlign: "center",
};

const Shipment = () => {
  const {
    paymentMode,
    indexOfPayment,
    startDate,
    endDate,
    handleDateChange,
    handlePaymentChange,
  } = useDashboardShipmentFilter();

  const { data: shipmentData } = useShipments(
    PaymentData[indexOfPayment].filter,
    startDate as Dayjs,
    endDate as Dayjs
  );

  return (
    <>
      <Stack
        direction={"row"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        marginBottom={"40px"}
        flexWrap={"wrap"}
      >
        <Stack
          direction={"row"}
          justifyContent={"center"}
          alignItems={"center"}
          columnGap={"40px"}
          rowGap={"30px"}
          flexWrap={"wrap"}
        >
          <DatePickerEl
            defaultDate={startDate}
            handleChange={(time) => handleDateChange(time, "start")}
            label="From"
          />
          <DatePickerEl
            defaultDate={endDate}
            handleChange={(time) => handleDateChange(time, "end")}
            label="To"
          />

          <Select
            sx={{
              minWidth: "150px",
            }}
            size="small"
            value={paymentMode}
            onChange={handlePaymentChange}
          >
            {PaymentData.map((el, index) => {
              return (
                <MenuItem key={index} value={el.field}>
                  {el.field}
                </MenuItem>
              );
            })}
          </Select>
        </Stack>
      </Stack>

      <TableContainer component={Card}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={tableCellStyle}>Service</TableCell>
              <TableCell sx={tableCellStyle}>Pickup Unscheduled</TableCell>
              <TableCell sx={tableCellStyle}>Booking Pending</TableCell>
              <TableCell sx={tableCellStyle}>Pickup Scheduled</TableCell>
              <TableCell sx={tableCellStyle}>In Transit</TableCell>
              <TableCell sx={tableCellStyle}>Exception</TableCell>
              <TableCell sx={tableCellStyle}>Delivered</TableCell>
              <TableCell sx={tableCellStyle}>RTO</TableCell>
              <TableCell sx={tableCellStyle}>Total Shipments</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {shipmentData &&
              shipmentData.map((el, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell sx={tableCellStyle}>{el.service}</TableCell>
                    <TableCell sx={tableCellStyle}>
                      {el.pickup_unscheduled}
                    </TableCell>
                    <TableCell sx={tableCellStyle}>
                      {el.booking_pending}
                    </TableCell>
                    <TableCell sx={tableCellStyle}>
                      {el.pickup_scheduled}
                    </TableCell>
                    <TableCell sx={tableCellStyle}>{el.in_transit}</TableCell>
                    <TableCell sx={tableCellStyle}>{el.exception}</TableCell>
                    <TableCell sx={tableCellStyle}>{el.delivered}</TableCell>
                    <TableCell sx={tableCellStyle}>{el.rto}</TableCell>
                    <TableCell sx={tableCellStyle}>
                      {el.total_shipments}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
        <NoDataFound data={shipmentData} />
      </TableContainer>
    </>
  );
};

export default Shipment;
